/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-reveal-header',
  templateUrl: './reveal-header.component.html',
  styleUrls: ['./reveal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RevealHeaderComponent {
  constructor() {}
}
